// import $ from 'jquery'
export default {
  install(Vue) {
    // 防重复点击(指令实现)
    Vue.directive('preventReClick', {
      inserted(el, binding) {
        el.addEventListener('click', () => {
          if (!el.disabled) {
            // $(el).addClass('is-disabled')
            el.disabled = true
            setTimeout(() => {
              // $(el).removeClass('is-disabled')
              el.disabled = false
            }, binding.value || 5000)
          }
        })
      }
    })
  }
}
